export const errorMsg = 'Server Error: Please try again later.';

export const confirmationMsg = {
  title: 'Message sent',
  msg: 'Your message has been sent successfully',
};
